import { render, staticRenderFns } from "./packResource.vue?vue&type=template&id=2084c347&scoped=true"
import script from "./packResource.vue?vue&type=script&lang=js"
export * from "./packResource.vue?vue&type=script&lang=js"
import style0 from "./packResource.vue?vue&type=style&index=0&id=2084c347&prod&scoped=true&lang=less"
import style1 from "./packResource.vue?vue&type=style&index=1&id=2084c347&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084c347",
  null
  
)

export default component.exports